var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('swiper-table',{attrs:{"title":"政策资讯","contentMode":_vm.ContentMode}})}
var staticRenderFns = []

export { render, staticRenderFns }